import {put, call, select} from 'redux-saga/effects'
import {UserActions} from '../../reducers/user/index'
import Api from '../../services/ApiCaller'
import {delay} from 'redux-saga'
import {jsonToFormData} from "../../utils/index";

export function * requestGetUserData(api) {
    yield call(Api.callServer, api.getUser, {}, function *(user) {
        if (user) {
            localStorage.setItem('role', user.role)
            localStorage.setItem('id', user.id)
            yield put(UserActions.getUserSuccess(user))
        } else {
            yield put(UserActions.getUserError('Invalid User'))
        }
    }, function *(error) {
        yield put(UserActions.getUserError(error))
    }, false)
}

export function * requestGetAllUserInfo(api, {selectedRoleType, pageNumber, searchText, filters = {}}) {
    let {user: {all: {pageSize = 0} = {}} = {}} = yield select()
    searchText = searchText && searchText.trim().length ? searchText : undefined

    if (searchText) {
        yield call(delay, 500)
    }

    let apiCall = api.getAllUserInfo;
    if(filters.patientType && filters.patientType !== 'All'){
        apiCall = api.getAllAvailableRiders;
    }

    yield call(Api.callServer, apiCall, {
        selectedRoleType,
        pageNumber,
        pageSize,
        searchText,
        filters
    }, function *(users) {
        if (users) {
            yield put(UserActions.getAllUserInfoSuccess(users, pageNumber, pageSize))
        }
    }, function *(error) {
        yield put(UserActions.getAllUserInfoError(error))
    }, false)
}

export function * requestSpecificUser(api, {user}) {
    const {id} = user
    yield call(Api.callServer, api.getSpecificUserInfo, {id}, function *(userInfo) {
        yield put(UserActions.getSpecificUserSuccess(userInfo))
    }, function *(error) {
        yield put(UserActions.getAllUserInfoError(error))
    }, false)
}

export function * sendSpecificUserInvite(api, {user}) {
    yield call(Api.callServer, api.sendSpecificUserInvite, {id: user.id}, function *(updatedUser) {
        if (updatedUser) {
            yield put(UserActions.sendSpecificUserInviteSuccess(updatedUser))
            const user = updatedUser
            // fetch self
            let {user: {me: {userInfo = {}} = {}} = {}} = yield select()
            if (userInfo.id === user.id) {
                yield put(UserActions.sendSpecificUserInviteSuccess(user))
            }
        }
    }, function *(error) {
        yield put(UserActions.updateSpecificUserError(error))
    }, false)
}

export function * requestUpdateSpecificUser(api, {user}) {
    const body = jsonToFormData(user);
    let updateCampaign = false;
    if(user.campaign){
        updateCampaign = true;
    }

    yield call(Api.callServer, api.updateSpecificUserInfo, {id: user.id, user: body}, function *(updatedUser) {
        if (updatedUser) {
            yield put(UserActions.updateSpecificUserSuccess(updatedUser, updateCampaign))
            const user = updatedUser
            // fetch self
            let {user: {me: {userInfo = {}} = {}} = {}} = yield select()
            if (userInfo.id === user.id) {
                yield put(UserActions.updateMeUserSuccess(user))
            }
        }
    }, function *(error) {
        yield put(UserActions.updateSpecificUserError(error))
    }, false)
}


export function * requestUserResetPassword(api, {password, newPassword}) {

    yield call(Api.callServer, api.updateUserPassword, {
        password, newPassword
    }, function *(user) {
        if (user) {
            yield put(UserActions.changePasswordSuccess(user))
        }
    }, function *(error) {
        yield put(UserActions.changePasswordError(error))
    }, false)
}

export function * requestCreateUser(api, {user}) {
    const body = jsonToFormData(user);

    yield call(Api.callServer, api.createUser, {id: user.id, user: body}, function *(newUser) {
        yield put(UserActions.createSpecificUserSuccess(newUser))
    }, function *(error) {
        yield put(UserActions.createSpecificUserError(error))
    }, false)
}


export function * userProfileRequest(api) {
    yield call(Api.callServer, api.getUserProfile, {}, function *(profile) {
        if (profile) {
            yield put(UserActions.getUserProfileSuccess(profile))
        }
    }, function *(error) {
        yield put(UserActions.getUserProfileError(error))
    }, false)
}


export function * requestCreateMultipleUser(api, {users}) {
    yield call(Api.callServer, api.createMultipleUser, users, function *(data) {
        if (data) {
            yield put(UserActions.createMultipleUserSuccess(true))
            // const {schoolId, parentsArray = []} = users
            // const counts = parentsArray.length
            // yield put(SchoolActions.updateSpecificSchoolCount(schoolId, counts));
        }
    }, function *(error) {
        console.log(error)
        yield put(UserActions.createMultipleUserError(error))
    }, false)
}
